// Rendered inside the router: applies a pending service-worker update at the next navigation,
// i.e. never while the employee is in the middle of a form.
import { useEffect } from "react";
import { useLocation } from "react-router";
import { reloadIfUpdatePending } from "./update-state";

export function PwaUpdateGate() {
  const { pathname } = useLocation();
  // biome-ignore lint/correctness/useExhaustiveDependencies: runs on every route change on purpose
  useEffect(() => {
    reloadIfUpdatePending();
  }, [pathname]);
  return null;
}
